export enum LayoutAttributes {
  fieldLabels = 1,
  quantities,
  groups,
  suppressRepeatingRows,
  wideLayout,
  totals,
  xAxisLabelsEnabled,
  yAxisLabelsEnabled,
  showValue,
  showPercent,
  hideDatalabelsOnDashboards,
  stacked,
  percent,
  donutView,
  semiCircleView
}

export interface AttributesPickerTranslation {
  attribute_field_labels: string;
  attribute_quantities: string;
  attribute_groups: string;
  attribute_wide_layout: string;
  attribute_totals: string;
  attribute_suppress_repeating_rows: string;
  attribute_xAxis_labels_enabled: string;
  attribute_yAxis_labels_enabled: string;
  attribute_show_value: string;
  attribute_show_percent: string;
  attribute_hide_datalabels_on_dashboards: string;
  attribute_stacked: string;
  attribute_percent: string;
  attribute_donut_view: string;
  attribute_semi_circle_view: string;
}
